import { generateUniqueId, stripTimestampAndExtension } from '@/assets/js/Utilities';
import AIAutoCorrectV2 from "@/assets/js/blocks/AIAutoCorrectV2";
import $ from "jquery";
import * as tf from "@tensorflow/tfjs";

export default class AIColourMatchV2 extends AIAutoCorrectV2 {
    constructor() {
        super();

        this.blockName = 'ai-colour-match-v2';
        this.version = "2.0.0";

        this.curveNames = ["WhiteBalance-R", "WhiteBalance-G", "WhiteBalance-B", "Tint-R", "Tint-G", "Tint-B"];

        this.exposure = {
            minValue: -5,
            maxValue: 5,
        }

        this.contrast = {
            minValue: -1,
            maxValue: 1,
            default: 0,
            defaultPivot: 0.435
        }

        this.whiteBalance = {
            minValue: -4000,
            maxValue: 4000,
            calcValue: 8000,
        };

        this.tint = {
            minValue: -100,
            maxValue: 100,
            calcValue: 100,
        };

        this.opacity = {
            minValue: 0,
            maxValue: 100,
        };
    }

    async addBlock(blockNum = lutify.blocks.length, selectedSampleFile = false) {
        UI.createAdjustmentBlockTemplate(this.blockName, blockNum);
        let element = UI.getAdjustmentBlock(blockNum);
        this.addRegenerateButton($(element));
        UI.removeBlockBlendingModes($(element));
        UI.appendBlockLoadingSpinner($(element))

        await super.loadModel();
        $(element).find(".expand_options").trigger("click", [false]);

        $(element)
            .find('[data-control="favor-neutrality"]')
            .on("change", async e => {
                blocks.checkSwitchHandler($(element));

                lutify.getActiveBlock().favourNeutrality = e.target.checked;
                lutify.getActiveBlock().favourContext = !e.target.checked;
                $(element).find('[data-control="favor-neutrality"]').prop('checked', e.target.checked);
                $(element).find('[data-control="favor-context"]').prop('checked', !e.target.checked);

                if (!lutify.getActiveBlock().sampleFile) return;
                let asset = vm.$store.getters["Projects/assetById"](lutify.getActiveBlock().sampleFile.id, lutify.getActiveBlock().sampleFile.type);
                let storeData = asset.type == 'media' ? await lutify.fetchImage(asset) : await lutify.fetchMatch(asset);
                await this.predictAll(storeData.imageIDTLMT);
                this.showPreviews();
                this.resetOpacity();
            })

        $(element)
            .find('[data-control="favor-context"]')
            .on("change", async e => {
                blocks.checkSwitchHandler($(element));

                lutify.getActiveBlock().favourContext = e.target.checked;
                lutify.getActiveBlock().favourNeutrality = !e.target.checked;
                $(element).find('[data-control="favor-context"]').prop('checked', e.target.checked);
                $(element).find('[data-control="favor-neutrality"]').prop('checked', !e.target.checked);

                if (!lutify.getActiveBlock().sampleFile) return;
                let asset = vm.$store.getters["Projects/assetById"](lutify.getActiveBlock().sampleFile.id, lutify.getActiveBlock().sampleFile.type);
                let storeData = asset.type == 'media' ? await lutify.fetchImage(asset) : await lutify.fetchMatch(asset);
                await this.predictAll(storeData.imageIDTLMT);
                this.showPreviews();
                this.resetOpacity();
            })

        $(element)
            .find('[data-control="direct-transfer"]')
            .on("change", async e => {
                blocks.checkSwitchHandler($(element));

                lutify.getActiveBlock().directTransfer = e.target.checked;

                if (e.target.checked) {
                    $(element).find('[data-control="favor-neutrality"]').parent().addClass('--disabled pointer-events-none')
                    $(element).find('[data-control="favor-context"]').parent().addClass('--disabled pointer-events-none')
                } else {
                    $(element).find('[data-control="favor-neutrality"]').parent().removeClass('--disabled pointer-events-none')
                    $(element).find('[data-control="favor-context"]').parent().removeClass('--disabled pointer-events-none')
                }

                if (!lutify.getActiveBlock().sampleFile) return;
                let asset = vm.$store.getters["Projects/assetById"](lutify.getActiveBlock().sampleFile.id, lutify.getActiveBlock().sampleFile.type);
                let storeData = asset.type == 'media' ? await lutify.fetchImage(asset) : await lutify.fetchMatch(asset);
                await this.predictAll(storeData.imageIDTLMT);
                this.showPreviews();
                this.resetOpacity();
            })

        $(element)
            .find(".exposure_slider")
            .on("input", () => this.exposureSliderHandler($(element)));
        $(element)
            .find(".exposure_range")
            .on("change", () => this.exposureValueHandler($(element)))

        $(element)
            .find(".contrast_slider")
            .on("input", () => this.contrastSliderHandler($(element)));
        $(element)
            .find(".contrast_range")
            .on("change", () => this.contrastValueHandler($(element)));

        $(element)
            .find(".white_balance_slider")
            .on("input", () => this.whiteBalanceHandler($(element)));
        $(element)
            .find(".white_balance_range")
            .on("change", () => this.whiteBalanceValueHandler($(element)));

        $(element)
            .find(".tint_slider")
            .on("input", _ => this.tintHandler($(element)));
        $(element)
            .find(".tint_range")
            .on("change", _ => this.tintValueHandler($(element)));

        $(element).find(".lut-selector__label-container").on("click", e => {
            e.stopPropagation();
            if ($(e.currentTarget).hasClass('disabled')) return;
            this.togglePresetSelector($(e.currentTarget));
        });

        $(element).find(".opacity_slider").on("input", e => this.opacitySliderHandler($(element), e));
        $(element).find(".opacity-input").on("change", e => this.opacityInputHandler($(element), e));

        $(element).find(".btn-reset-block").on("click", e => {
            e.stopPropagation();
            this.resetBlock($(element));
        });

        $(element).on("click", e => {
            e.stopImmediatePropagation();
            // UI.hideLUTtemplates();
            if (!lutify.getActiveBlock().sampleFile) return;
            if (!luts['LUTcontrols'][`AIColourMatch-${lutify.getActiveBlock().passes[4].uid}`]) return;
            if (luts['LUTcontrols'][`AIColourMatch-${lutify.getActiveBlock().passes[4].uid}`].length == 0) return;
            this.showPreviews();
        });

        $(element).find('.sample-selector').on('click', e => {
            vm.$root.projectTree.openAIColourMatchModalV2(vm.$store.state.Projects.currentFile, 'updateAIColourMatchSample');
        });

        UI.initKnob(element, {
            size: 30,
        });

        blocks.add({
            name: "AIColourMatchV2",
            passes: this.addPasses(),
            version: this.version,
            curves: [],
            blockNum,
            blendingMode: 0,
            blendingModeName: "Normal",
            predictions: [],
            predictionsContent: [],
            presetId: null,
            sampleFile: null,
            opacity: 100,
            favourContext: true,
            favourNeutrality: false,
            directTransfer: false,
            values: {
                exposure: 0,
                contrast: this.contrast.default,
                pivot: this.contrast.defaultPivot,
                whiteBalance: 0,
                tint: 0,
            }
        });

        $(element).find(".lut-selector__items-container").hide();

        blocks.createCurves(this.curveNames, blockNum);

        UI.removeBlockLoadingSpinner($(UI.getActiveBlock()));

        if (!vm.$store.state.UI.showAddMatchTooltip && vm.$store.getters['Projects/allMatches'].length == 0) {
            vm.$store.dispatch('UI/setAddMatchTooltip', "Please load a reference image first, then save it as a Match using the option above to start using the AI Colour Match tool");
        }
    }

    async loadLuts() {
        vm.$store.dispatch("Loader/showProgressBar", "indeterminate");
        UI.appendBlockLoadingSpinner($(UI.getActiveBlock()));

        UI.togglePreviewsContainer();
        lutPreviewer.showPlaceholderPreviews()

        let data = {
            control: 'LUTcontrols',
            category: 'White Balance'
        }

        await _Adjustments.LUTcontrols.load(data);

        if (typeof luts['LUTcontrols'][`AIColourMatch-${lutify.getActiveBlock().passes[4].uid}`] == "undefined") luts['LUTcontrols'][`AIColourMatch-${lutify.getActiveBlock().passes[4].uid}`] = [];
        let lutObjectsList = []

        let lutObjectClone = { ...lutify.getActiveBlock().lutObjects[0] };
        lutObjectClone.category = `AIColourMatch-${lutify.getActiveBlock().passes[4].uid}`;
        lutObjectClone.presetId = 0;
        lutObjectClone.title = 'The Magic Look';
        luts['LUTcontrols'][`AIColourMatch-${lutify.getActiveBlock().passes[4].uid}`].push(lutObjectClone);
        lutPreviewer.createPreviews([lutObjectClone], false, undefined, 'AIColourMatchV2');
        lutObjectsList.push(lutObjectClone);

        for await (const [key, lutObject] of luts[data.control][data.category].entries()) {
            let lutObjectClone = { ...lutObject };
            lutObjectClone.category = `AIColourMatch-${lutify.getActiveBlock().passes[4].uid}`;
            lutObjectClone.presetId = key + 1;
            let titleSplitted = lutObjectClone.title.split(/(\-|\+)/g);
            lutObjectClone.title = `The Magic Look ${titleSplitted[1]} WB ${titleSplitted[2]}`;

            luts['LUTcontrols'][`AIColourMatch-${lutify.getActiveBlock().passes[4].uid}`].push(lutObjectClone);
            lutPreviewer.createPreviews([lutObjectClone], false, undefined, 'AIColourMatchV2');
            lutObjectsList.push(lutObjectClone);
        }

        this.setPresetList(lutObjectsList);

        vm.$store.dispatch("Loader/showProgressBar", false);
        UI.removeBlockLoadingSpinner($(UI.getActiveBlock()));
        lutPreviewer.removePlaceholderPreviews();
        UI.getActiveBlock().click();
    }

    addPasses() {
        let shaderPass_exposure = gpu.createLiftGammaGainPass();
        let shaderPass_contrast = gpu.createLiftGammaGainPass();
        let shaderPass_wb = gpu.createCurveShaderPass("white balance");
        let shaderPass_tint = gpu.createCurveShaderPass("tint");
        let passCreativeLut = gpu.createRenderPass();
        let passAIAutoCorrectForward = gpu.createRenderPass();
        let passAIAutoCorrectReverse = gpu.createRenderPass();

        gpu.addPassToComposer(shaderPass_exposure, "toMiddle");
        gpu.addPassToComposer(shaderPass_contrast, "toMiddle");
        gpu.addPassToComposer(shaderPass_wb, "toMiddle");
        gpu.addPassToComposer(shaderPass_tint, "toMiddle");
        gpu.addPassToComposer(passCreativeLut, "toMiddle");
        gpu.addPassToComposer(passAIAutoCorrectForward, "toMiddle");
        gpu.addPassToComposer(passAIAutoCorrectReverse, "toMiddle");

        return [shaderPass_exposure, shaderPass_contrast, shaderPass_wb, shaderPass_tint, passCreativeLut, passAIAutoCorrectForward, passAIAutoCorrectReverse];
    }

    togglePresetSelector($el) {
        let itemsContainer = $el.siblings(".lut-selector__items-container");
        if (itemsContainer.is(":visible")) itemsContainer.hide();
        else itemsContainer.show();
    }

    onPresetSelection(el, preset) {
        let category = 'AIColourMatch-' + lutify.getActiveBlock().passes[4].uid;
        $(`#previews-list-container .list-item[data-category="${category}"][data-preset-id="${preset.presetId}"]`).trigger('click');
        this.updatePresetList(preset);
    }

    updatePresetList(preset = false) {
        let $lutSelector = $(UI.getActiveBlock()).find(".lut-selector");
        $lutSelector.find(".lut-selector__items-container").hide();
        $lutSelector
            .find(`.lut-selector__items-container .--selected`)
            .removeClass("--selected");

        if (lutify.getActiveBlock().presetId !== null && preset) {
            $lutSelector.find(".selected-lut-name").html('Look: ' + preset.title);
            $lutSelector
                .find(`.lut-selector__items-container span[data-preset-id="${preset.presetId}"]`).addClass("--selected");
        } else {
            $lutSelector.find(".selected-lut-name").html('Select Look...');
        }
    }

    setPresetList(presets) {
        let $block = UI.getActiveBlock();

        presets.forEach(preset => {
            let el = document.createElement('span');
            el.innerHTML = preset.title;
            el.setAttribute('data-preset-id', preset.presetId);
            el.addEventListener('click', e => {
                this.onPresetSelection(e.currentTarget, preset);
            });

            $block.find('.lut-selector__items-container').append(el)
        });
    }

    async setSampleFile(file, lastState = false) {
        vm.$store.dispatch("Loader/showProgressBar", "indeterminate");
        $(UI.getActiveBlock()).find('.btn-block-needs-update').addClass('hide');

        blocks.checkSwitchHandler($(UI.getActiveBlock()));

        let activeBlock = lutify.getActiveBlock();
        activeBlock.passes[4].uid = generateUniqueId();
        activeBlock.sampleFile = {
            id: file.id,
            type: file.type,
        };

        let asset = vm.$store.getters["Projects/assetById"](file.id, file.type);
        let storeData = asset.type == 'media' ? await lutify.fetchImage(asset) : await lutify.fetchMatch(asset);

        if (!lastState) {
            await this.predictAll(storeData.imageIDTLMT);
        }

        await this.loadLuts();
        this.resetOpacity();

        if (!lastState) $(`#previews-list-container [data-category="AIColourMatch-${activeBlock.passes[4].uid}"][data-preset-id="0"] .scene`).trigger('click');

        $(UI.getActiveBlock()).find('.lut-selector__label-container').removeClass('disabled');
        this.setSampleFileUI(storeData.blob, asset.name);
        vm.$store.dispatch("Loader/showProgressBar", false);
    }

    setSampleFileUI(imageBlob, name) {
        if (!lutify.getActiveBlock()) return;
        let block = UI.getActiveBlock();
        let $block = $(block);

        let imgSrc = URL.createObjectURL(imageBlob);
        let imgElement = document.createElement('img');
        imgElement.setAttribute('src', imgSrc);
        imgElement.setAttribute('class', 'thumbnail');
        imgElement.setAttribute('data-tippy-content', 'Click to change a Match');
        $block.find('.sample-selector img').remove();
        $block.find('.sample-selector .select-asset-btn').addClass('hide');
        $block.find('.sample-selector').prepend(imgElement);

        name = stripTimestampAndExtension(name);
        $block.find('.sample-selector .name').text(`Selected Match: ${name}`);
    }

    resetSampleFileUI() {
        if (!lutify.getActiveBlock()) return;
        let $block = UI.getActiveBlock();

        $block.find('.sample-selector img').remove();
        $block.find('.sample-selector .select-asset-btn').removeClass('hide');
        $block.find('.sample-selector .name').text(``);
    }

    async predictAll(sourceBlob) {
        let imageURL = URL.createObjectURL(sourceBlob);

        const predictionsForward = await this.predict();
        const predictionsReverse = await this.predict(imageURL, false);

        this.setPredictions(predictionsForward, predictionsReverse)
        URL.revokeObjectURL(imageURL);
    }

    setPredictions(predictionsForward, predictionsReverse) {
        lutify.getActiveBlock().predictions[0] = predictionsForward.neutrality.lutFile;
        lutify.getActiveBlock().predictions[1] = predictionsReverse.neutrality.lutFile;
        lutify.getActiveBlock().predictions[2] = predictionsForward.context.lutFile;
        lutify.getActiveBlock().predictionsContent[0] = predictionsForward.neutrality.lutContent;
        lutify.getActiveBlock().predictionsContent[1] = predictionsReverse.neutrality.lutContent;
        lutify.getActiveBlock().predictionsContent[2] = predictionsForward.context.lutContent;

        if (lutify.getActiveBlock().favourNeutrality) {
            this.applyForwardPass(predictionsForward.neutrality.lutFile);
            this.applyReversePass(predictionsReverse.neutrality.lutFile);
            lutify.getActiveBlock().lutObjects = [predictionsForward.neutrality.lutFile, predictionsReverse.neutrality.lutFile];
        } else {
            this.applyForwardPass(predictionsForward.context.lutFile);
            this.applyReversePass(predictionsReverse.neutrality.lutFile);
            lutify.getActiveBlock().lutObjects = [predictionsForward.context.lutFile, predictionsReverse.neutrality.lutFile];
        }
    }

    async predict(imageURL = null, forward = true) {
        let blockNum = blocks.getBlockIndex_byBlockNum(lutify.getActiveBlock().blockNum);
        let passes = blocks.getAllPassesToBlock(blockNum);

        // check the image size for when using larged media sizes
        if (!imageURL) imageURL = lutify.getIDTLMTimage(passes, false); // getting the main canvas image with IDT LMT

        let imageElement = new Image();
        imageElement.src = imageURL;
        await imageElement.decode();

        let tensor = tf.browser.fromPixels(imageElement);

        tensor = tf.cast(tensor, 'float32');
        tensor = this.resize(tensor, this.img_size);
        let image = this.normalize(tensor);

        let image_reshaped = tf.reshape(image, [1, this.img_size, this.img_size, 3]);

        const targetNeutrality = await this.modelFavourNeutrality.apply(image_reshaped, { 'training': true });
        const targetContext = await this.modelFavourContext.apply(image_reshaped, { 'training': true });

        if (forward) {
            const {
                lutFile: lutFileNeutralityForward,
                lutContent: lutContentNeutralityForward
            } = await this.getLutFromTarget(targetNeutrality, image);

            const {
                lutFile: lutFileContextForward,
                lutContent: lutContentContextForward
            } = await this.getLutFromTarget(targetContext, image);

            return {
                neutrality: {
                    lutFile: lutFileNeutralityForward,
                    lutContent: lutContentNeutralityForward
                },
                context: {
                    lutFile: lutFileContextForward,
                    lutContent: lutContentContextForward
                }
            }
        } else {
            const {
                lutFile: lutFileNeutralityReverse,
                lutContent: lutContentNeutralityReverse
            } = await this.getLutFromTarget(targetNeutrality, image, false);

            return {
                neutrality: {
                    lutFile: lutFileNeutralityReverse,
                    lutContent: lutContentNeutralityReverse
                }
            }
        }
    }

    applyForwardPass(LUT) {
        let pass = gpu.createLUTPass(LUT.texture);
        pass.uid = lutify.getActiveBlock().passes[5].uid;
        pass.name = "AI Auto Correct - Forward";
        pass.enabled = lutify.getActiveBlock().directTransfer ? false : true;
        let index = gpu.getPassIndexById(lutify.getActiveBlock().passes[5].uid);
        gpu.composer.passes[index] = pass;
        lutify.getActiveBlock().passes[5] = pass;
        gpu.render();
    }

    applyReversePass(LUT) {
        let pass = gpu.createLUTPass(LUT.texture);
        pass.uid = lutify.getActiveBlock().passes[6].uid;
        pass.name = "AI Auto Correct - Reverse";
        let index = gpu.getPassIndexById(lutify.getActiveBlock().passes[6].uid);
        gpu.composer.passes[index] = pass;
        lutify.getActiveBlock().passes[6] = pass;
        gpu.render();
    }

    exposureSliderHandler($el) {
        blocks.checkSwitchHandler($el);
        lutify.getActiveBlock().passes[0].enabled = true;

        let exposureValue = UI.getAdjustmentBlock_sliderValue($el, 0);
        UI.setAdjustmentBlock_rangeValue($el, exposureValue, 0);

        let block = lutify.getActiveBlock();
        block.values.exposure = exposureValue;
        block.passes[0].uniforms.exposure.value = exposureValue;
        gpu.render();
    }

    exposureValueHandler($el) {
        blocks.checkSwitchHandler($el);
        lutify.getActiveBlock().passes[0].enabled = true;

        let exposureValue = UI.getAdjustmentBlock_rangeValue($el, 0);

        if (exposureValue > this.maxValue) {
            exposureValue = this.maxValue;
            UI.setAdjustmentBlock_rangeValue($el, exposureValue, 0);
        }
        if (exposureValue < this.minValue) {
            exposureValue = this.minValue;
            UI.setAdjustmentBlock_rangeValue($el, exposureValue, 0);
        }

        UI.setAdjustmentBlock_sliderValue($el, exposureValue, 0);
        lutify.getActiveBlock().values.exposure = exposureValue;
        lutify.getActiveBlock().passes[0].uniforms.exposure.value = exposureValue;
        gpu.render();
    }

    contrastSliderHandler($el) {
        blocks.checkSwitchHandler($el);
        lutify.getActiveBlock().passes[1].enabled = true;

        let contrastValue = UI.getAdjustmentBlock_sliderValue($el, 1);
        UI.setAdjustmentBlock_rangeValue($el, contrastValue, 1);

        let block = lutify.getActiveBlock();
        block.values.contrast = contrastValue;
        block.passes[1].uniforms.contrast.value = contrastValue;
        gpu.render();
    }

    contrastValueHandler($el) {
        blocks.checkSwitchHandler($el);
        lutify.getActiveBlock().passes[1].enabled = true;

        let contrastValue = UI.getAdjustmentBlock_rangeValue($el, 1);

        if (contrastValue > this.maxValue) {
            contrastValue = this.maxValue;
            UI.setAdjustmentBlock_rangeValue($el, contrastValue, 1);
        }
        if (contrastValue < this.minValue) {
            contrastValue = this.minValue;
            UI.setAdjustmentBlock_rangeValue($el, contrastValue, 1);
        }

        UI.setAdjustmentBlock_sliderValue($el, contrastValue, 1);
        lutify.getActiveBlock().values.contrast = contrastValue;
        lutify.getActiveBlock().passes[1].uniforms.contrast.value = contrastValue;
        gpu.render();
    }

    whiteBalanceHandler($el) {
        blocks.checkSwitchHandler($el);
        lutify.getActiveBlock().passes[2].enabled = true;

        let whiteValue = UI.getAdjustmentBlock_sliderValue($el, 2);
        UI.setAdjustmentBlock_rangeValue($el, whiteValue, 2);

        let block = lutify.getActiveBlock();
        block.values.whiteBalance = whiteValue;
        this.curveWBalance(block.values.whiteBalance);
    }

    tintHandler($el) {
        blocks.checkSwitchHandler($el);
        lutify.getActiveBlock().passes[3].enabled = true;

        let tintValue = UI.getAdjustmentBlock_sliderValue($el, 3);
        UI.setAdjustmentBlock_rangeValue($el, tintValue, 3);

        let block = lutify.getActiveBlock();
        block.values.tint = tintValue / this.tint.calcValue;
        this.curveTint(block.values.tint);
    }

    whiteBalanceValueHandler($el) {
        blocks.checkSwitchHandler($el);
        lutify.getActiveBlock().passes[2].enabled = true;

        let whiteValue = UI.getAdjustmentBlock_rangeValue($el, 2);

        if (whiteValue > this.whiteBalance.maxValue || whiteValue < this.whiteBalance.minValue) {
            if (whiteValue < this.whiteBalance.minValue) {
                whiteValue = this.whiteBalance.minValue;
                UI.setAdjustmentBlock_rangeValue($el, whiteValue, 2);
            } else {
                whiteValue = this.whiteBalance.maxValue;
                UI.setAdjustmentBlock_rangeValue($el, whiteValue, 2);
            }
        }

        UI.setAdjustmentBlock_sliderValue($el, whiteValue, 2);
        lutify.getActiveBlock().values.whiteBalance = whiteValue;
        this.curveWBalance(lutify.getActiveBlock().values.whiteBalance);
    }

    tintValueHandler($el) {
        blocks.checkSwitchHandler($el);
        lutify.getActiveBlock().passes[3].enabled = true;

        var tintValue = UI.getAdjustmentBlock_rangeValue($el, 3);

        if (tintValue > this.tint.maxValue) {
            tintValue = this.tint.maxValue;
            UI.setAdjustmentBlock_rangeValue($el, tintValue, 3);
        }
        if (tintValue < this.tint.minValue) {
            tintValue = this.tint.minValue;
            UI.setAdjustmentBlock_rangeValue($el, tintValue, 3);
        }

        UI.setAdjustmentBlock_sliderValue($el, tintValue, 3);
        lutify.getActiveBlock().values.tint = tintValue / this.tint.calcValue;
        this.curveTint(lutify.getActiveBlock().values.tint);
    }

    curveWBalance(wbValue) {
        let curveR = lutify.getActiveBlock().curves[0].colorCurve;
        let curveG = lutify.getActiveBlock().curves[1].colorCurve;
        let curveB = lutify.getActiveBlock().curves[2].colorCurve;

        curveR.points = [];
        curveG.points = [];
        curveB.points = [];

        if (wbValue >= 0) {
            curveR.points.push({ x: 0.0, y: 0.0 + wbValue * 0.00001569 });
            curveR.points.push({ x: 1.0 - wbValue * 0.00001472, y: 1.0 });

            curveG.points.push({ x: 0.0, y: 0.0 + wbValue * 0.00000784 });
            curveG.points.push({ x: 1.0, y: 1.0 - wbValue * 0.00000784 });

            curveB.points.push({ x: 0.0, y: 0.0 + wbValue * 0.0000155 });
            curveB.points.push({ x: 0.188, y: 0.188 - wbValue * 0.00001175 });
            curveB.points.push({ x: 1.0, y: 1.0 - wbValue * 0.00002275 });
        } else if (wbValue < 0) {
            curveR.points.push({ x: 0.0 + Math.abs(wbValue) * 0.00001569, y: 0.0 });
            curveR.points.push({ x: 1.0, y: 1.0 - Math.abs(wbValue) * 0.00001472 });

            curveG.points.push({ x: 0.0 + wbValue * 0.00000784, y: 0.0 });
            curveG.points.push({ x: 1.0 - wbValue * 0.00000784, y: 1.0 });

            curveB.points.push({ x: 0.0 + Math.abs(wbValue) * 0.00001569, y: 0.0 });
            curveB.points.push({ x: 0.188, y: 0.188 + Math.abs(wbValue) * 0.00002163 });
            curveB.points.push({ x: 0.25, y: 0.25 + Math.abs(wbValue) * 0.00002672 });
            curveB.points.push({ x: 0.376, y: 0.376 + Math.abs(wbValue) * 0.00003247 });
            curveB.points.push({ x: 0.5, y: 0.5 + Math.abs(wbValue) * 0.00003382 });
            curveB.points.push({ x: 1.0 - Math.abs(wbValue) * 0.00002275, y: 1.0 });
        }

        curveR.draw();
        curveG.draw();
        curveB.draw();
        curveR.updateValues();
        curveG.updateValues();
        curveB.updateValues();

        this.callGPUWbalance(curveR.rgb, curveG.rgb, curveB.rgb);
    }

    curveTint(tintValue) {
        let curveR = lutify.getActiveBlock().curves[3].colorCurve;
        let curveG = lutify.getActiveBlock().curves[4].colorCurve;
        let curveB = lutify.getActiveBlock().curves[5].colorCurve;

        curveR.points = [];
        curveG.points = [];
        curveB.points = [];

        if (tintValue < 0) {
            curveR.points.push({ x: 0.0, y: 0.0 });
            curveR.points.push({ x: 1.0, y: 1 + tintValue * 0.1372 });

            curveG.points.push({ x: 0.0, y: 0.0 });
            curveG.points.push({ x: 0.9523, y: 0.9523 - tintValue * 0.047 });
            curveG.points.push({ x: 1.0, y: 1.0 });

            curveB.points.push({ x: 0.0, y: 0.0 });
            curveB.points.push({ x: 1.0, y: 1 + tintValue * 0.10588 });
        } else if (tintValue >= 0) {
            curveR.points.push({ x: 0.0, y: 0.0 });
            curveR.points.push({ x: 1.0 - tintValue * 0.12156, y: 1.0 });

            curveG.points.push({ x: 0.0, y: 0.0 });
            curveG.points.push({ x: 1.0, y: 1.0 - tintValue * 0.05882 });

            curveB.points.push({ x: 0.0, y: 0.0 });
            curveB.points.push({ x: 1.0 - tintValue * 0.09019, y: 1.0 });
        }

        curveR.draw();
        curveG.draw();
        curveB.draw();
        curveR.updateValues();
        curveG.updateValues();
        curveB.updateValues();

        this.callGPUTint(curveR.rgb, curveG.rgb, curveB.rgb);
    }

    callGPUWbalance(pointsRed, pointsGreen, pointsBlue) {
        let curveTexture = gpu.RGBPointsToCurve(pointsRed, pointsGreen, pointsBlue);
        lutify.getActiveBlock().passes[2].uniforms["map"].value = curveTexture;
        gpu.render();
    }

    callGPUTint(pointsRed, pointsGreen, pointsBlue) {
        let curveTexture = gpu.RGBPointsToCurve(pointsRed, pointsGreen, pointsBlue);
        lutify.getActiveBlock().passes[3].uniforms["map"].value = curveTexture;
        gpu.render();
    }

    resetBlock($element) {
        this.resetOpacity();

        $element.find(".exposure_range").val(0);
        $element.find(".exposure_range").trigger('change');

        $element.find(".contrast_range").val(0);
        $element.find(".contrast_range").trigger('change');

        $element.find(".white_balance_range").val(0);
        $element.find(".white_balance_range").trigger('change');

        $element.find(".white_balance_range").val(0);
        $element.find(".white_balance_range").trigger('change');

        $element.find(".tint_range").val(0);
        $element.find(".tint_range").trigger('change');

        UI.hideLUTtemplates();
        lutify.getActiveBlock().sampleFile = null;
        lutify.getActiveBlock().presetId = null;
        this.resetSampleFileUI();

        if (lutify.getActiveBlock().favourNeutrality) {
            $element.find('[data-control="favor-context"]').trigger('click');
        }

        if (lutify.getActiveBlock().directTransfer) {
            $element.find('[data-control="direct-transfer"').trigger('click');
        }

        this.updatePresetList();
        $(UI.getActiveBlock()).find('.lut-selector__label-container').addClass('disabled');

        lutify.getActiveBlock().passes.forEach(pass => pass.enabled = false);

        gpu.render();
    }

    resetOpacity() {
        $(UI.getActiveBlock()).find(".opacity-input").val(100);
        $(UI.getActiveBlock()).find(".opacity-input").trigger("change");
    }

    showPreviews() {
        lutify.selectedPreviewCategory = `AIColourMatch-${lutify.getActiveBlock().passes[4].uid}`;

        UI.togglePreviewsContainer();
        UI.updatePreviewsTab('AI Colour Match');
        lutPreviewer.switchCanvases(`AIColourMatch-${lutify.getActiveBlock().passes[4].uid}`);
        // UI.updateSelectedPreview(lutify.getActiveBlock().selectedPreview);

        lutPreviewer.cloneMainComposerPasses();
        lutPreviewer.addPass('LUTcontrols', `AIColourMatch-${lutify.getActiveBlock().passes[4].uid}`, 4, lutify.getActiveBlock().blendingMode, 'AIColourMatchV2');

        if (lutify.getActiveBlock().presetId) {
            let preset = luts['LUTcontrols'][`AIColourMatch-${lutify.getActiveBlock().passes[4].uid}`].find(preset => preset.presetId == lutify.getActiveBlock().presetId)
            UI.updateSelectedPreview(preset.composerIndex);
        }

        lutPreviewer.render();
        setTimeout(() => lutPreviewer.render(), 50); // because of visual glitch
    }

    opacitySliderHandler($element, e) {
        let opacityValue = e.currentTarget.value;
        let calcOpacityValue = opacityValue * 0.01;

        $element.find(".opacity-input").val(opacityValue);

        lutify.getActiveBlock().opacity = opacityValue;
        lutify.getActiveBlock().passes[4].uniforms.opacity.value = calcOpacityValue;
        lutify.getActiveBlock().passes[5].uniforms.opacity.value = calcOpacityValue;
        lutify.getActiveBlock().passes[6].uniforms.opacity.value = calcOpacityValue;

        if (lutify.getActiveBlock().sampleFile) {
            lutPreviewer.updateOpacity(calcOpacityValue, 4);
            lutPreviewer.updateOpacity(calcOpacityValue, 5);
            lutPreviewer.updateOpacity(calcOpacityValue, 6);
        }

        gpu.render();
        lutPreviewer.render();
    }

    opacityInputHandler($element, e) {
        let opacityValue = e.currentTarget.value;
        let opacitySlider = $element.find(".opacity_slider");

        if (opacityValue > this.opacity.maxValue) opacityValue = this.opacity.maxValue;
        if (opacityValue < this.opacity.minValue) opacityValue = this.opacity.minValue;

        opacitySlider.val(opacityValue);
        opacitySlider.trigger("input");
    }

    addRegenerateButton($element) {
        let icon = document.createElement('i')
        icon.setAttribute('class', 'btn-block-regenerate material-icons')
        icon.setAttribute('data-tippy-content', 'Regenerate')
        icon.innerHTML = 'loop'
        icon.addEventListener('click', async () => {
            UI.appendBlockLoadingSpinner($element)

            if (!lutify.getActiveBlock().sampleFile) {
                UI.removeBlockLoadingSpinner($element)
                return;
            }

            let asset = vm.$store.getters["Projects/assetById"](lutify.getActiveBlock().sampleFile.id, lutify.getActiveBlock().sampleFile.type);
            let storeData = asset.type == 'media' ? await lutify.fetchImage(asset) : await lutify.fetchMatch(asset);
            await this.predictAll(storeData.imageIDTLMT);

            this.showPreviews();
            this.resetOpacity();

            UI.removeBlockLoadingSpinner($element)
        })
        $element.find('.header-container .controls-wrapper').prepend(icon)
    }

    async applyChanges($block, values, blockData) {
        let activeBlockData = lutify.getActiveBlock();
        vm.$store.dispatch('App/setBlockLoading', true);
        $('#blocks-container--outer').addClass('--overlay');
        $('#project-navigator-container').addClass('--overlay');
        $('#filmstrip-container .thumbnail-container').addClass('--overlay');

        try {
            const exposure = values.exposure;
            const contrast = values.contrast;
            const whiteBalance = values.whiteBalance;
            const tint = values.tint * this.tint.calcValue;
            UI.setAdjustmentBlock_rangeValue($block, exposure, 0);
            UI.setAdjustmentBlock_rangeValue($block, contrast, 1);
            UI.setAdjustmentBlock_rangeValue($block, whiteBalance, 2);
            UI.setAdjustmentBlock_rangeValue($block, tint, 3);
            $block.find(".exposure_range").trigger("change");
            $block.find(".contrast_range").trigger("change");
            $block.find(".white_balance_range").trigger("change");
            $block.find(".tint_range").trigger("change");

            $block.find(".opacity-input").val(parseInt(blockData.opacity));
            $block.find(".opacity-input").trigger("change");

            activeBlockData.presetId = blockData.presetId;

            if (!blockData.sampleFile) return;

            if (!vm.$store.getters["Projects/assetById"](blockData.sampleFile.id, blockData.sampleFile.type)) {
                vm.$snackbar('Selected Match for AI Colour Match is no longer available. Please select a new one or otherwise remove the AI Colour Match tool.', 'error', {
                    timeout: -1,
                    contentClass: 'text-center'
                });
                return;
            }

            lutify.getActiveBlock().favourContext = blockData.favourContext;
            lutify.getActiveBlock().favourNeutrality = blockData.favourNeutrality;
            lutify.getActiveBlock().directTransfer = blockData.directTransfer;
            $block.find('[data-control="favor-context"]').prop('checked', blockData.favourContext);
            $block.find('[data-control="favor-neutrality"]').prop('checked', blockData.favourNeutrality);
            $block.find('[data-control="direct-transfer"]').prop('checked', blockData.directTransfer);

            if (blockData.directTransfer) {
                $block.find('[data-control="favor-neutrality"]').parent().addClass('--disabled pointer-events-none')
                $block.find('[data-control="favor-context"]').parent().addClass('--disabled pointer-events-none')
            }

            const neutralityForwardLut = await this.createLutFileFromContent(blockData.predictionsContent[0]);
            const neutralityReverseLut = await this.createLutFileFromContent(blockData.predictionsContent[1]);
            const contextForwardLut = await this.createLutFileFromContent(blockData.predictionsContent[2]);

            lutify.getActiveBlock().predictions[0] = neutralityForwardLut;
            lutify.getActiveBlock().predictions[1] = neutralityReverseLut;
            lutify.getActiveBlock().predictions[2] = contextForwardLut;
            lutify.getActiveBlock().predictionsContent[0] = blockData.predictionsContent[0];
            lutify.getActiveBlock().predictionsContent[1] = blockData.predictionsContent[1];
            lutify.getActiveBlock().predictionsContent[2] = blockData.predictionsContent[2];

            if (lutify.getActiveBlock().favourNeutrality) {
                this.applyForwardPass(neutralityForwardLut);
                this.applyReversePass(neutralityReverseLut);
                lutify.getActiveBlock().lutObjects = [neutralityForwardLut, neutralityReverseLut];
            } else {
                this.applyForwardPass(contextForwardLut);
                this.applyReversePass(neutralityReverseLut);
                lutify.getActiveBlock().lutObjects = [contextForwardLut, neutralityReverseLut];
            }

            await this.setSampleFile(blockData.sampleFile, true);

            if (blockData.presetId !== null) {
                let preset = luts['LUTcontrols'][`AIColourMatch-${activeBlockData.passes[4].uid}`].find(preset => preset.presetId == activeBlockData.presetId);
                let pass = gpu.createLUTPass(preset.texture);
                pass.name = "lut-" + blockData.presetId;
                pass.uid = activeBlockData.passes[4].uid;
                pass.uniforms.opacity.value = activeBlockData.opacity * 0.01;
                if (blockData.presetId == '0') pass.enabled = false;

                activeBlockData.passes[4] = pass;
                let passIndex = gpu.getPassIndexById(pass.uid);
                gpu.composer.passes[passIndex] = activeBlockData.passes[4];

                $block.find(".opacity-input").val(parseInt(blockData.opacity));
                $block.find(".opacity-input").trigger("change");

                gpu.render();
                lutPreviewer.render();

                window.lutify.getActiveBlock().collapsedPreviews = blockData.collapsedPreviews;

                this.updatePresetList(preset);
            }

            $block.find(".controls-wrapper .switch > input").trigger("click");
        } finally {
            vm.$store.dispatch('App/setBlockLoading', false);
            $('#blocks-container--outer').removeClass('--overlay');
            $('#project-navigator-container').removeClass('--overlay');
            $('#filmstrip-container .thumbnail-container').removeClass('--overlay');
            vm.$store.dispatch("Loader/showProgressBar", false);
        }
    }
}
